"use client";

import { Check, Info } from "lucide-react";
import { useState } from "react";
import { SpecItem } from "./types";

interface SpecRowProps {
  spec: SpecItem;
}

export default function SpecRow({ spec }: SpecRowProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  const { name, valueA, valueB, tooltip, winner } = spec;

  return (
    <tr className="spec-row">
      <td className="spec-name-cell">
        <div className="spec-name-wrapper">
          <span>{name}</span>
          {tooltip && (
            <div
              className="tooltip-wrapper"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            >
              <Info size={12} className="tooltip-icon" />
              {showTooltip && <div className="tooltip-bubble">{tooltip}</div>}
            </div>
          )}
        </div>
      </td>
      <td className={`spec-val-cell ${winner === "A" ? "winner-cell" : ""}`}>
        <div className="value-wrapper">
          {winner === "A" && <Check size={14} className="winner-icon" />}
          <span>{valueA}</span>
        </div>
      </td>
      <td className={`spec-val-cell ${winner === "B" ? "winner-cell" : ""}`}>
        <div className="value-wrapper">
          {winner === "B" && <Check size={14} className="winner-icon" />}
          <span>{valueB}</span>
        </div>
      </td>

      <style jsx>{`
        .spec-row {
          border-bottom: 1px solid var(--border-color);
        }
        .spec-row:last-child {
          border-bottom: none;
        }
        td {
          padding: var(--space-4) var(--space-5);
          font-family: var(--font-body);
          font-size: var(--text-sm);
          color: var(--text-secondary);
          vertical-align: middle;
          font-weight: var(--fw-semibold);
        }
        .spec-name-cell {
          width: 30%;
          color: var(--text-primary);
          font-weight: var(--fw-extrabold);
        }
        .spec-name-wrapper {
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .tooltip-wrapper {
          position: relative;
          display: inline-flex;
          cursor: help;
        }
        .tooltip-icon {
          color: var(--text-muted);
        }
        .tooltip-bubble {
          position: absolute;
          bottom: 125%;
          left: 50%;
          transform: translateX(-50%);
          background-color: var(--bg-surface);
          border: 1px solid var(--border-color);
          color: var(--text-secondary);
          padding: var(--space-2) var(--space-3);
          border-radius: var(--radius-sm);
          font-size: var(--text-2xs);
          width: 220px;
          z-index: 100;
          box-shadow: var(--card-shadow);
          font-weight: var(--fw-medium);
          line-height: 1.4;
          text-align: center;
        }
        .tooltip-bubble::after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          border-width: 5px;
          border-style: solid;
          border-color: var(--border-color) transparent transparent transparent;
        }
        .spec-val-cell {
          width: 35%;
        }
        .winner-cell {
          background-color: var(--primary-light);
          color: var(--text-primary);
        }
        .value-wrapper {
          display: flex;
          align-items: center;
          gap: var(--space-2);
        }
        .winner-icon {
          color: var(--primary);
          flex-shrink: 0;
        }
      `}</style>
    </tr>
  );
}
